import { render, staticRenderFns } from "./ServicesReference.vue?vue&type=template&id=5767f8aa"
import script from "./ServicesReference.vue?vue&type=script&lang=js"
export * from "./ServicesReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports